import { Button, PickerView, Popup, Toast } from "antd-mobile";
import { PickerColumnItem, PickerValue } from "antd-mobile/es/components/picker-view";
import classNames from "classnames";
import React, { useEffect, useRef, useState } from "react";
import styles from "./styles.module.scss";

// @ts-ignore
import { areaList } from "@vant/area-data";
import "./styles.module.scss";
interface LooseObjType<T = any> {
  [key: string]: T;
}
export type AreaPickerValue = PickerColumnItem;
interface AreaPickerProps {
  visible: boolean; // picker是否显示
  className?: string;
  onClose: () => void; // picker内部点击关闭或遮罩时
  onConfirm?: (val: AreaPickerValue[]) => void;
}
const AreaPicker: React.FC<AreaPickerProps> = props => {
  const {
    visible,
    className,
    onClose,
    onConfirm
  } = props;
  const {
    province_list,
    city_list
  } = areaList; // 省市区

  // 变化的值（change）
  const [value, setValue] = useState<PickerValue[]>(["", ""]);
  // const [ value, setValue ] = useState<PickerValue[]>([ '', '', '' ])
  // 确定的值（confirm 点击确定按钮后记录）
  const determinantVal = useRef<PickerValue[]>(["", ""]);
  // const determinantVal = useRef<PickerValue[]>([ '', '', '' ])

  const [provinceList, setProvinceList] = useState<PickerColumnItem[]>([]);
  const [cityList, setCityList] = useState<PickerColumnItem[]>([]);
  // const [ countyList, setCountyList ] = useState<PickerColumnItem[]>([])

  const classes = classNames("area-picker-popup", className);

  // 处理地区数据
  const processAreaData = (source: LooseObjType): PickerColumnItem[] => {
    return [{
      label: "请选择",
      value: ""
    }, ...Object.keys(source).map(key => ({
      label: source[key],
      value: key
    }))];
  };

  // 根据传入的值设置城市和区县列表
  const updateCityAndCountyList = (currentVal: PickerValue[]) => {
    const [provinceVal] = currentVal;
    const cityList = JSON.parse(JSON.stringify(city_list)); // 浅拷贝
    // const countyList = JSON.parse(JSON.stringify(county_list))

    if (provinceVal) {
      const _pattern = new RegExp(`^${`${provinceVal}`.slice(0, 2)}`);
      for (const k in cityList) {
        if (!_pattern.test(k)) {
          delete cityList[k];
        }
      }
      setCityList(processAreaData(cityList));
    } else {
      setCityList([]);
    }

    /* if (cityVal) {
      const _pattern = new RegExp(`^${`${cityVal}`.slice(0, 4)}`)
      for (const k in countyList) {
        if (!_pattern.test(k)) {
          delete countyList[k]
        }
      }
      setCountyList(processAreaData(countyList))
    } else {
      setCountyList([])
    } */
  };

  // 点击确定按钮
  const handleConfirm = () => {
    determinantVal.current = [...value];
    if (!value[0]) {
      return Toast.show({
        content: "请选择省市"
      });
    }
    if (!value[1]) {
      return Toast.show({
        content: "请选择城市"
      });
    }
    const province = provinceList.find(item => item.value === value[0]);
    const city = cityList.find(item => item.value === value[1]);
    const _value: AreaPickerValue[] = province && city ? [province, city] : [];
    onClose();
    onConfirm && onConfirm(_value);
  };

  // 滑动选择时，根据省筛选市 根据市筛选区县
  const handleChange = (val: PickerValue[]) => {
    updateCityAndCountyList(val);
    setValue(val);
  };

  // mounted时设置省列表
  useEffect(() => {
    setProvinceList(processAreaData(province_list));
  }, []);

  // 当弹框显示时设置上次点确定时的值和列表
  useEffect(() => {
    if (visible) {
      updateCityAndCountyList(determinantVal.current);
      setValue(determinantVal.current);
    }
  }, [visible]);
  return <Popup className={classes} visible={visible} onMaskClick={onClose} data-sentry-element="Popup" data-sentry-component="AreaPicker" data-sentry-source-file="AreaPicker.tsx">
      <div className={classNames(styles.actions, "popup-hd fx fx-hb fx-vc")}>
        <Button fill="none" onClick={onClose} className={classNames(styles.action)} data-sentry-element="Button" data-sentry-source-file="AreaPicker.tsx">
          取消
        </Button>
        <Button color="primary" fill="none" onClick={() => {
        handleConfirm();
      }} className={classNames(styles.action, styles.action_submit)} data-sentry-element="Button" data-sentry-source-file="AreaPicker.tsx">
          确定
        </Button>
      </div>
      <div className="popup-bd">
        <PickerView
      // columns={[ provinceList, cityList, countyList ]}
      columns={[provinceList, cityList]} value={value} onChange={val => handleChange(val)} data-sentry-element="PickerView" data-sentry-source-file="AreaPicker.tsx" />
      </div>
    </Popup>;
};
export default AreaPicker;